import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import firebase from "firebase/app";
import "firebase/auth";
import VueParticles from "vue-particles";

Vue.use(Buefy)
Vue.use(VueParticles)

Vue.config.productionTip = false

console.log(firebase)

let app
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})